import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import { adminApi } from '../../lib/adminApi';

export default function AdminNavigationList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function loadItems() {
    try {
      setLoading(true);
      setError('');
      const data = await adminApi('/api/admin/navigation-items');
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { loadItems(); }, []);

  async function deleteItem(id) {
    if (!window.confirm('Delete this navigation item?')) return;
    try {
      await adminApi(`/api/admin/navigation-items/${id}`, { method: 'DELETE' });
      setItems((current) => current.filter((item) => item.id !== id));
    } catch (err) {
      alert(err.message);
    }
  }

  return (
    <AdminLayout
      title="Mega Menu Manager"
      subtitle="Control the public Explore FPB mega menu without editing code."
      actions={<Link to="/adxm/navigation/create" className="rounded-xl bg-emerald-700 px-4 py-3 text-sm font-black text-white hover:bg-emerald-800">+ Add Menu Item</Link>}
    >
      {error && <div className="mb-4 rounded-xl border border-red-200 bg-red-50 p-4 text-sm font-bold text-red-700">{error}</div>}
      {loading ? <div className="rounded-2xl bg-white p-6 font-bold text-slate-600 shadow-sm">Loading menu items...</div> : (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <table className="min-w-full divide-y divide-slate-200 text-sm">
            <thead className="bg-slate-50 text-left text-xs font-black uppercase tracking-wider text-slate-500">
              <tr><th className="px-5 py-4">Title</th><th className="px-5 py-4">Group</th><th className="px-5 py-4">URL</th><th className="px-5 py-4">Status</th><th className="px-5 py-4 text-right">Action</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((item) => (
                <tr key={item.id}>
                  <td className="px-5 py-4 font-black text-slate-950">{item.title}</td>
                  <td className="px-5 py-4 text-slate-600">{item.group_name}</td>
                  <td className="px-5 py-4 text-slate-600">{item.url}</td>
                  <td className="px-5 py-4"><span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-700">{item.status}</span></td>
                  <td className="px-5 py-4">
                    <div className="flex justify-end gap-2">
                      <Link to={`/adxm/navigation/edit/${item.id}`} className="rounded-lg border border-slate-200 px-3 py-2 font-bold text-slate-700 hover:bg-slate-100">Edit</Link>
                      <button onClick={() => deleteItem(item.id)} className="rounded-lg border border-red-200 px-3 py-2 font-bold text-red-700 hover:bg-red-50">Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan="5" className="px-5 py-10 text-center font-bold text-slate-500">No menu item found.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}
